import * as React from "react";
import { AppContext } from "@1js/acui-context";
import { checkExperiment } from "@1js/acui-experiments";

export const useAsyncReactUITiming = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    "SharedOnline.ChangeGate.OfficeVSO:8836674_AsyncReactUITiming"
  );
};
